var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "unauth-layout",
    [
      _c(
        "template",
        { slot: "page-content" },
        [
          _c("h2", { attrs: { id: "moto" } }, [
            _vm._v("\n\t\t\ta free\n\t\t\t"),
            _c(
              "span",
              { staticStyle: { "border-bottom": "2px dashed #ccc" } },
              [_vm._v("user-owned")]
            ),
            _vm._v(" storage solution for (web)apps\n\t\t")
          ]),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c("div", {
            attrs: { id: "toc" },
            domProps: { innerHTML: _vm._s(_vm.tocSource) }
          }),
          _vm._v(" "),
          _c("vue-markdown", {
            staticClass: "markdown readme",
            attrs: {
              source: _vm.mainMD,
              watches: [
                "show",
                "html",
                "breaks",
                "linkify",
                "emoji",
                "typographer",
                "toc"
              ],
              show: _vm.show,
              html: _vm.html,
              breaks: _vm.breaks,
              linkify: _vm.linkify,
              emoji: _vm.emoji,
              typographer: _vm.typographer,
              toc: _vm.toc,
              "toc-id": "toc",
              "toc-anchor-link": false,
              "toc-anchor-link-symbol": "#"
            },
            on: { rendered: _vm.allRight, "toc-rendered": _vm.tocAllRight }
          }),
          _vm._v(" "),
          _c("div", { attrs: { id: "footer-firstpage" } })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("vue-markdown", {
      staticClass: "markdown",
      attrs: { source: _vm.forwhoMD }
    })
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-753901df", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-753901df","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FirstPage.vue
// module id = null
// module chunks = 